import React, { Component } from 'react';

import ErrorModal from './ErrorModal';

class MainForm extends Component {
  state = {
    property: '',
    resources: '',
    creditYears: '',
    interest: '',
    isOpen: false,
  };

  calculate = (property, resources, creditYears, interest) => {
    const monthlyInterest = (interest / 12) / 100;
    const months = creditYears * 12;
    let vyskaUveru = property - resources;
    const monthlyPayment = Math.round(vyskaUveru * (monthlyInterest / (1 - ((1 / (monthlyInterest + 1)) ** months))));
    vyskaUveru = vyskaUveru.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return {
      monthlyPayment,
      vyskaUveru,
      interest: interest.toString().split('.').join(','),
      creditYears,
    };
  }

  onPropertyChange = (e) => {
    let property = e.target.value;
    if (!property || property.match(/^\d{1,}(\.\d{0,})*$/)) {
      property = property.split('.').join('');
      property = property.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      this.setState(() => ({ property }));
    }
  };

  onResourcesChange = (e) => {
    let resources = e.target.value;
    if (!resources || resources.match(/^\d{1,}(\.\d{0,})*$/)) {
      resources = resources.split('.').join('');
      resources = resources.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      this.setState(() => ({ resources }));
    }
  };

  onCreditYearsChange = (e) => {
    const creditYears = e.target.value;
    if (!creditYears || creditYears.match(/^[0-9]*$/)) {
      this.setState(() => ({ creditYears }));
    }
  };

  onInterestChange = (e) => {
    let interest = e.target.value;
    if (!interest || interest.match(/^\d{1,}(\.|,\d{0,3})?$/)) {
      interest = interest.split('.').join(',');
      this.setState(() => ({ interest }));
    }
  };

  closeModal = () => {
    this.setState(() => ({ isOpen: false }));
  }

  openModal = () => {
    this.setState(() => ({ isOpen: true }));
  }

  onSubmit = (e) => {
    let {
      property,
      resources,
      interest,
      creditYears,
    } = this.state;
    const { setCalculated, setResult, setConsultation } = this.props;
    e.preventDefault();
    property = parseInt(property.split('.').join(''), 10);
    resources = parseInt(resources.split('.').join(''), 10);
    interest = parseFloat(interest.split(',').join('.'), 10);
    creditYears = parseInt(creditYears, 10);
    if (resources > property) {
      this.openModal();
    } else {
      if (resources < property * 0.2) {
        setConsultation();
      }
      const result = this.calculate(property, resources, creditYears, interest);
      setResult(result);
      setCalculated();
    }
  };

  render() {
    const {
      creditYears,
      property,
      resources,
      interest,
      isOpen,
    } = this.state;
    return (
      <form className="main-form" onSubmit={this.onSubmit}>
        <div>
          <div className="main-form__item">
            <label className="form-label" htmlFor="property">Hodnota nehnuteľnosti</label>
            <input
              className="form-input"
              id="property"
              onChange={this.onPropertyChange}
              required
              value={property}
            />
          </div>
          <div className="main-form__item">
            <label className="form-label" htmlFor="resources">Vlastné zdroje</label>
            <input
              className="form-input"
              id="resources"
              onChange={this.onResourcesChange}
              required
              value={resources}
            />
          </div>
          <div className="main-form__item">
            <label className="form-label" htmlFor="credit-years">Dĺžka úveru v rokoch</label>
            <input
              className="form-input"
              id="credit-years"
              onChange={this.onCreditYearsChange}
              required
              type="text"
              value={creditYears}
            />
          </div>
          <div className="main-form__item">
            <label className="form-label" htmlFor="interest">Úroková sadzba v %</label>
            <input
              className="form-input"
              id="interest"
              onChange={this.onInterestChange}
              required
              value={interest}
            />
          </div>
        </div>
        <button className="btn btn--calculate" type="submit">Vypočítať</button>
        <ErrorModal isOpen={isOpen} closeModal={this.closeModal} />
      </form>
    );
  }
}

export default MainForm;
